import { categoryLabel } from '@/lib/format';

const COLORS: Record<string, { bg: string; text: string }> = {
  elections: { bg: 'bg-accent', text: 'text-bg-base' },
  conflicts: { bg: 'bg-pink', text: 'text-white' },
  diplomacy: { bg: 'bg-theme-diplomacy', text: 'text-white' },
  sanctions: { bg: 'bg-warn', text: 'text-bg-base' },
  domestic: { bg: 'bg-theme-domestic', text: 'text-bg-base' },
  geopolitics: { bg: 'bg-theme-geopolitics', text: 'text-white' },
};

export function CategoryBadge({ category }: { category: string }) {
  const cls = COLORS[category] ?? { bg: 'bg-bg-elev2', text: 'text-text-secondary' };
  return (
    <span
      className={`px-2 py-1 text-[10px] display tracking-[0.08em] ${cls.bg} ${cls.text}`}
    >
      {categoryLabel(category).toUpperCase()}
    </span>
  );
}
